module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Volver")])])])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('c-lista-cursos-virtuales-clases', {
    on: {
      "volver": function($event) {
        return _vm.volver()
      },
      "cfetch": function($event) {
        return _vm.cfetch()
      }
    }
  })], 1), (_vm.showMateriales || _vm.showEvaluaciones) ? _c('div', {
    key: "box-cajas",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [(_vm.showMateriales || _vm.showEvaluaciones) ? _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showMateriales) ? _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('materiales-clase-lista', {
    ref: "materiales",
    attrs: {
      "modulo": 'alumno',
      "type": 'clase',
      "fetchURL": _vm.fetchURLMaterial
    },
    on: {
      "close": function($event) {
        return _vm.close('showMateriales')
      }
    }
  })], 1) : _vm._e(), (_vm.showEvaluaciones) ? _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('evaluaciones-clase-lista', {
    ref: "evaluaciones",
    attrs: {
      "type": 'clase',
      "modulo": 'alumno',
      "fetchURL": _vm.fetchURLEvaluacion
    },
    on: {
      "close": function($event) {
        return _vm.close('showEvaluaciones')
      }
    }
  })], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1011f8f2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Cursos_Virtuales_Video.vue
// module id = 752
// module chunks = 0